module.exports = __webpack_public_path__ + "static/media/red-x-icon.3e0a5598.svg";